@if (showBackdrop) {
  <div
    #backdropEl
    class="shared-popover-backdrop"
    [class.is-open]="isRendered"
    [class.visible]="isVisible"
    (click)="onBackdropClick()">
  </div>
}

<div
  #containerEl
  class="shared-popover-container"
  [ngClass]="cssClassList"
  [class.is-open]="isRendered"
  [class.visible]="isVisible"
  role="dialog"
  [attr.aria-hidden]="!isRendered"
  [attr.aria-label]="ariaLabel"
  [style.top.px]="popoverTop"
  [style.left.px]="popoverLeft"
  (click)="onContentClick($event)">
  <div class="shared-popover-content">
    <ng-content></ng-content>
  </div>
</div>
